<template>
    <div class="home" :class="{'isFixed': isFixed2}">
        <div class="top" :class="$iosHeight()">
            <div class="head" :class="$iosHeight()">
                <span @click="onBack"><img src="../../../assets/img/b2b/icon_back_white@2x.png" alt=""></span>
                <div class="title">爆款专区</div>
            </div>
            <div class="cont">
                <span>优/惠/好/货</span>
                <span>不/容/错/过</span>
            </div>
        </div>
        <div class="gods" :class="{'ptop64': height === 'isIos', 'ptop88': height === 'isIos2'}">
            <GoodsList ref="goodsList" screenType='0' :isTop='isTop'></GoodsList>
        </div>
    </div>
</template>
<script>
import GoodsList from '../goods/common/navTab'
import { mapState } from 'vuex'
export default {
    name: 'more',
    computed: {
        ...mapState({
            getUserInfo: state => state.b2b.userInfo
        })
    },
    components: {
        GoodsList
    },
    data () {
        return {
            title: '爆款专区',
            titleRight: '',
            companyCode: '',
            merchantCode: '',
            updateUid: '',
            isFixed: true,
            isFixed2: false,
            icon: false,
            height: 0,
            isTop: 'more'
        }
    },
    methods: {
        onBack () { // 返回
            this.$router.push('/b2b/home/index')
        }
    },
    mounted () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            this.height = 'isIos'
            this.isTop = 'isTop64'
        } else if (parseInt(iosHeight) === 88) {
            this.height = 'isIos2'
            this.isTop = 'isTop88'
        }
        this.title = this.$route.query.type
        this.$refs.goodsList.onFaddish('1')
    }
}
</script>
<style lang="scss" scoped>
    .isFixed {
        position: fixed !important;
        z-index: 999;
    }
    .ptop64{
        padding-top: 250px !important;
    }
    .ptop88{
        padding-top: 300px !important;
    }
    .home{
        position: relative;
        font-size: 28px;
        padding-bottom: 100px;
        .gods{
            position: relative;
            padding-top: 200px;
        }
        .top{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: 210px;
            background: url(../../../assets/img/b2b/image_top@2x.png) no-repeat;
            background-size: 100% 100%;
            z-index: 999;
            .cont{
                width: 524px;
                padding-top: 124px;
                font-size: 30px;
                color: #ffffff;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                span{
                    letter-spacing: 10px;
                }
            }
        }
        .head{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            text-align: center;
            font-size: 36px;
            letter-spacing: 10px;
            line-height: 80px;
            font-weight: bold;
            color: #ffffff;
            span{
                position: absolute;
                left: 0;
                width: 80px;
                height: 80px;
            }
        }
        .btn{
            margin: 0 24px;
            background: #ffffff;
            padding: 28px 0;
            text-align: center;
            font-size: 32px;
            border-radius: 12px;
        }
        .homeList{
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 24px;
            .homeLi{
                width: 344px;
                // height: 508px;
                margin-bottom: 20px;
                background: #ffffff;
                border-radius: 12px;
                position: relative;
                overflow: hidden;
                .img{
                    width: 100%;
                    height: 344px;
                    vertical-align: bottom;
                    position: relative;
                    img{
                        width: 100%;
                        vertical-align: middle;
                    }
                }
                .foot{
                    position: absolute;
                    top: 312px;
                    span{
                        display: inline-block;
                        margin-right: 8px;
                        &.b2, &.b3{
                            width: 64px;
                            height: 32px;
                        }
                        &.b1{
                            width: 42px;
                            height: 32px;
                        }
                    }
                }
                .content{
                    padding: 24px 20px 18px;
                    .name{
                        height: 64px;
                        line-height: 34px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    .price{
                        margin-top: 18px;
                        color: #FF7A45;
                        font-size: 30px;
                        sub{
                            font-size: 20px;
                        }
                        span{
                            font-size: 24px;
                            color: #999999;
                            text-decoration: line-through;
                            margin-left: 20px;
                            sub{
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
        .shopCard{
            width: 164px;
            height: 164px;
            text-align: center;
            border-radius: 50%;
            background: url(../../../assets/img/b2b/shopCard.png) no-repeat;
            background-size: 100% 100%;
            position: fixed;
            right: 0;
            bottom: 100px;
            span{
                background-color: #fff;
                width: 36px;
                line-height: 36px;
                border: 2px solid #FF6B00;
                color: #FF6B00;
                border-radius: 50%;
                font-size: 24px;
                position: absolute;
                top: 30px;
                right: 30px;
            }
        }
        .mint-popup{
            border-radius: 16px;
            background: #ffffff;
        }
        .bannerImg{
            width: 590px;
            height: 590px;
            img{
                width: 100%;
                height: 100%;
                border-radius: 16px;
            }
        }
        .btnClose{
            position: fixed;
            width: 64px;
            height: 64px;
            bottom: -104px;
            left: 50%;
            -webkit-transform: translate3d(-50%, 0, 0);
            transform: translate3d(-50%, 0, 0);
        }
    }
    .arrow:after{
        top: 25px;
    }
</style>